import styled from 'styled-components'

const StyledCaptionList = styled.div`
  padding: 0 0 120px 0;
  box-sizing: border-box;

  .captions-view-header {
    padding: 12px 12px;
  }
`

export default StyledCaptionList
